<div class="content">
    <div class="tlr-bluetag-container">
      <div class="section-title">Recommended Repair Date within 90 Days without an ACTIVE Maximo WO</div>
  
      <div class="table-chart-container mt-10">
        <div class="exportToExcel excel-btn">
          <button (click)="exportToExcel()">Export To Excel</button>
        </div>
        <p-table [value]="permanentRepairDateData" [paginator]="true"  [rows]="10" responsiveLayout="scroll">
          <ng-template pTemplate="header">
            <tr>
              <th>Tag Number</th>
              <th>Entry Date</th>
              <th>Oper User ID</th>
              <th>Division</th>
              <th>Section</th>
              <th>Plant</th>
              <th>LDAR</th>
              <th>Op. PSI</th>
              <th>Op. Temp</th>
              <th>Service</th>
              <th>Insp User ID</th>
              <th>Service Class</th>
              <th>OA User ID</th>
              <th>Permanent Repair Date</th>
              <th>Eng User ID</th>
              <th>TLR Type</th>
              <th>Maximo WO Number</th>
              <th>Maximo Outage- T/A</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-detail>
            <tr *ngFor="let detail of permanentRepairDateData">
              <td><a routerLink="/details-section/{{detail.Tag_Number}}">
                {{ detail.Tag_Number }}</a></td>
              <td>{{detail.Data_Entry_Date | date:'MM/dd/yyyy'}}</td>
              <td>{{detail.Operator_CAI}}</td>
              <td class="left-align">{{detail.Division}}</td>
              <td class="left-align">{{detail.Section}}</td>
              <td class="left-align">{{detail.Plant}}</td>
              <td class="left-align">{{detail.LDAR}}</td>
              <td>{{detail.Oper_PSI}}</td>
              <td>{{detail.Oper_Temp}}</td>
              <td>{{detail.Service}}</td>
              <td>{{detail.InspectionCAI}}</td>
              <td>{{detail.ServiceClass}}</td>
              <td>{{detail.OACAI}}</td>
              <td>
                <span [ngClass]="commonService.getDateColorClass(detail.Permanent_Repair_Date)"> {{ detail.Permanent_Repair_Date| date: 'MM/dd/yyyy' }}</span>
              </td>
              <td>{{detail.EngineeringCAI}}</td>
              <td>{{detail.TLRType}}</td>
              <td>{{detail.Maximo_WO_Number}}</td>
              <td>{{detail.Maximo_Outage_T_A}}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>